import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const StyledLowerActionPanel = styled.div`
  /* Make text etc within slider unselectable */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */

  touch-action: none;

  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
  background-color: #fff;

  z-index: 1000;

  transition: bottom 0.2s;

  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;

  @media screen and (max-width: 600px) {
    position: fixed;
    width: 100%;
    top: unset !important;   // Override top value being set in Javascript to track map anchor
    left: 0px !important;    // Same here
    bottom: ${props => props.open ? '0px' : '-250px'};
    border-radius: 20px 20px 0px 0px;
    padding-bottom: calc(var(--app-safe-area-inset-bottom) + 20px);
  }

  @media screen and (min-width: 601px) {
    position: absolute;
    width: 600px;
    bottom: ${props => props.open ? '10px' : '-300px'};
    
    padding-bottom: 10px;
    border-radius: 20px;

    // Center a fixed div (https://stackoverflow.com/questions/3157372/css-horizontal-centering-of-a-fixed-div)
    margin-left: -300px;
    left: 50%;
  }
`;

const CloseActionArea = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
`;

const disableTouch = (e) => {
  e.preventDefault();
};

function LowerActionPanel({ open, onClose, children }) {
  return (
    <StyledLowerActionPanel open={open} onTouchStart={disableTouch}>
      <CloseActionArea>
        <IconButton onClick={onClose}>
            <CloseIcon />
        </IconButton>
      </CloseActionArea>
      {children}
    </StyledLowerActionPanel>
  );
}

LowerActionPanel.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default LowerActionPanel;
